/**
 * お気に入りボタン
 */
import Favorite from "./favorite";
import Template from '../../../lib/Template';
import {__} from "../lang/translator";

class FavoriteButton
{
  /**
   * constructor
   * @param {Element} button お気に入りボタン要素
   * @param {Array} bookmarkOfficeIds お気に入り物件のID
   */
  constructor(button, bookmarkOfficeIds)
  {
    this.button = button;
    this.officeId = button.getAttribute('data-bookmark-button');

    // お気に入りの初期状態をセット
    this.isBookmarked = bookmarkOfficeIds.includes(this.officeId)

    // ボタンの更新イベント
    this.updateEvent = new CustomEvent('update-bookmark', {
      detail: {
        bookmarkButton: this
      }
    });

    // ボタンのテンプレート要素を取得
    const template = document.querySelector(`[data-template="${this.button.getAttribute('data-template-container')}"]`);

    if (!template) throw new Error('templateが存在しません');

    // テンプレートを初期化
    this.template = new Template(template);

    // 初期化
    this.initialize();
  }

  /**
   * 初期化処理.
   */
  initialize()
  {
    // テンプレートを更新
    this.updateTemplate();

    // クリックイベントを登録
    this.button.addEventListener('click', this.clickEventHandler.bind(this));

    // お気に入りボタンの更新イベントを登録
    window.addEventListener('update-bookmark', this.updateOtherEventHandler.bind(this));
  }

  /**
   * お気に入りボタンの更新イベント.
   *
   * @param {Event} event
   */
  updateOtherEventHandler(event)
  {
    // 自分自身のイベントは除外する
    if (event.detail.bookmarkButton === this) return;

    // 同じ物件IDのお気に入りボタンのテンプレートを更新
    if (event.detail.bookmarkButton.officeId === this.officeId) {
      // イベントを発火したボタンのお気に入り済みフラグを取得／セット
      this.isBookmarked = event.detail.bookmarkButton.isBookmarked

      // テンプレートを更新
      this.updateTemplate();
    }

  }

  /**
   * ボタンの更新
   */
  clickEventHandler()
  {
    // 追加済みの場合は お気に入り ページに移動
    if (this.isBookmarked) {
      window.location = route('web.favorite');
    }
    // 未追加 => 追加
    else {
      (async() => {
        // お気に入り追加リクエスト
        const response = await Favorite.add([this.officeId]);

        // 処理成功
        if (response.data && response.data.status) {
          // お気に入り済みフラグをTrue
          this.isBookmarked = true;

          // テンプレートの更新
          this.updateTemplate();

          // 更新イベントを発火
          window.dispatchEvent(this.updateEvent);
        }
        // 処理失敗
        else {
          alert(response.data && response.data.message ? response.data.message : __('favorite.register.basic-error'));
        }
      })();
    }
  }

  /**
   * テンプレートを更新.
   *
   */
  updateTemplate()
  {
    this.template.insert(this.button, {
      isBookmarked: this.isBookmarked,
      officeId: this.officeId
    });
  }
}

export default FavoriteButton
